module.exports = function() {
	return new Worker(__webpack_public_path__ + "f15dee1f8d15c6c3833b.accounts.wrkr.js");
};